var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMesSondages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0714 0H1.92857C0.863839 0 0 0.863839 0 1.92857V16.0714C0 17.1362 0.863839 18 1.92857 18H16.0714C17.1362 18 18 17.1362 18 16.0714V1.92857C18 0.863839 17.1362 0 16.0714 0ZM6.42857 13.5C6.42857 13.8552 6.14089 14.1429 5.78571 14.1429H4.5C4.14482 14.1429 3.85714 13.8552 3.85714 13.5V8.35714C3.85714 8.00196 4.14482 7.71429 4.5 7.71429H5.78571C6.14089 7.71429 6.42857 8.00196 6.42857 8.35714V13.5ZM10.2857 13.5C10.2857 13.8552 9.99804 14.1429 9.64286 14.1429H8.35714C8.00196 14.1429 7.71429 13.8552 7.71429 13.5V4.5C7.71429 4.14482 8.00196 3.85714 8.35714 3.85714H9.64286C9.99804 3.85714 10.2857 4.14482 10.2857 4.5V13.5ZM14.1429 13.5C14.1429 13.8552 13.8552 14.1429 13.5 14.1429H12.2143C11.8591 14.1429 11.5714 13.8552 11.5714 13.5V10.9286C11.5714 10.5734 11.8591 10.2857 12.2143 10.2857H13.5C13.8552 10.2857 14.1429 10.5734 14.1429 10.9286V13.5Z",
    fill: "#2E4A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesSondages);
export default __webpack_public_path__ + "static/media/MesSondages.8aa2f443a653ef37db5148be3f4a4634.svg";
export { ForwardRef as ReactComponent };